import { DisplayedMeeting } from '../types';

export type MeetingYearGroup = {
  year: string;
  meetings: DisplayedMeeting[];
};

/**
 * Splits the register: upcoming meetings soonest first, past meetings latest first and grouped
 * by year (the calendar tile only shows the day and month).
 */
export function groupMeetings(meetings: DisplayedMeeting[], now: Date = new Date()) {
  const upcoming: DisplayedMeeting[] = [];
  const past: DisplayedMeeting[] = [];

  for (const meeting of meetings) {
    (new Date(meeting.start_time) >= now ? upcoming : past).push(meeting);
  }

  upcoming.sort((a, b) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime());
  past.sort((a, b) => new Date(b.start_time).getTime() - new Date(a.start_time).getTime());

  const pastByYear: MeetingYearGroup[] = [];
  for (const meeting of past) {
    const year = String(new Date(meeting.start_time).getFullYear());
    const group = pastByYear[pastByYear.length - 1];

    if (group?.year === year) {
      group.meetings.push(meeting);
    } else {
      pastByYear.push({ year, meetings: [meeting] });
    }
  }

  return { upcoming, pastByYear };
}
